export const buildQueryString = (query) => {
  const queryKeys = Object.keys(query);
  let queryString = "";
  queryKeys.map(
    (key, i) => (queryString += (i > 0 ? "&" : "?") + key + "=" + query[key])
  );
  return queryString;
};

export const capitalizeString = (string) => {
  return `${string[0].toUpperCase()}${string.substring(1).toLowerCase()}`;
};

export const buildBookingRef = (id) => {
  const ref = "MDS000000";
  const idLength = id.toString().length;
  return `${ref.slice(0, -idLength)}${id}`;
};

export const getOptionLabel = (options, value) => {
  return options.filter((o) => o.value === value)[0].label;
};

export const getOptionValue = (options, label) => {
  return options.filter((o) => o.label === label)[0].value;
};
